import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import { ReactNode } from 'react';

import { useTrackItemCardClicked } from '@/utils/amplitude/analytics';

import type { CoverLotData } from '../types';

import { CoverLotImage, THUMB_IMAGE_SIZE } from '../CoverLotImage';
import { CountdownBadge } from './CountdownBadge';

type Props = {
    completionTime: number;
    countdownLabel: ReactNode;
    coverLots: CoverLotData[];
    doneOverlay: ReactNode;
    hideCountdown?: boolean;
    onCountdownComplete?: () => void;
    trackItemCardClicked: ReturnType<typeof useTrackItemCardClicked>;
};

export const MobileImageCluster = ({
    completionTime,
    countdownLabel,
    coverLots,
    doneOverlay,
    hideCountdown = false,
    onCountdownComplete,
    trackItemCardClicked,
}: Props) => (
    <div className="relative flex w-full rounded-md border border-border-secondary bg-background-primary">
        {coverLots.map((lot, index) => (
            <div
                key={lot.itemId}
                className={cn(
                    'flex aspect-square min-w-0 flex-1 items-center justify-center overflow-hidden',
                    index < coverLots.length - 1 && 'border-r border-border-secondary'
                )}
            >
                <CoverLotImage
                    alt={lot.title}
                    catalogId={lot.catalogId}
                    href={lot.url}
                    imageSize={THUMB_IMAGE_SIZE}
                    itemId={lot.itemId}
                    promoted={lot.promoted}
                    src={lot.image}
                    srcSet={`${lot.imageHighDpi} 2x`}
                    trackItemCardClicked={trackItemCardClicked}
                />
            </div>
        ))}
        {doneOverlay}
        <CountdownBadge
            completionTime={completionTime}
            hideCountdown={hideCountdown}
            isMobile
            label={countdownLabel}
            onComplete={onCountdownComplete}
        />
    </div>
);
